<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const reachCardSchema = defineSchema({
	heading: $.text('Heading'),
	description: $.text('Description', { multiline: true }),
})
const defaults = {
	title: 'Reach and Impact',
	description: 'The Academic Torah Institute serves a broad and diverse audience, including clergy, educators, students, and laypeople seeking intellectually rigorous yet accessible engagement with the Bible, Talmud, and other Jewish texts.',
	reachFooter: '',
	reachCards: [
		{
			heading: 'Authors -',
			description: 'Over 580 contributing scholars from universities across the globe including: Harvard, Columbia, MIT, Duke, Brown, NYU (USA), Hebrew U., Tel Aviv U., Bar-Ilan U., Haifa U. (Israel), Oxford and Cambridge (UK), and universities in Canada, Australia, Germany, Netherlands, Finland and Japan.',
		},
		{
			heading: 'Scholarship',
			description: 'across academic disciplines, including history, archaeology, ancient Near Eastern studies, Egyptology, Semitic languages, textual criticism, literary criticism, and source criticism, among other fields.',
		},
		{
			heading: 'Readership -',
			description: 'Millions of page visits annually across our English and Hebrew platforms.',
		},
		{
			heading: 'Credibility -',
			description: 'University professors trust and assign our articles as required reading, and clergy and educators rely on our resources for teaching and study.',
		},
	],
}
const schema = defineSchema({
	title: $.text('Title'),
	description: $.text('Description', { multiline: true }),
	reachCards: $.array('Impact Cards', reachCardSchema, { collapsible: true }),
	reachFooter: $.text('Footer Text (optional)'),
})
export const Reach = defineBlock({ name: 'Reach', label: 'Reach & Impact', icon: 'public', order: 4, schema, defaults })
</script>
<script setup lang="ts">

import { Card, $ } from '@bagelink/vue'
defineProps<{
	title?: string
	description?: string
	reachFooter?: string
	reachCards?: Array<{ heading: string, description: string }>
}>()

// Function to clean HTML tags from text
function cleanHtml(text: string): string {
	if (!text) return ''
	// Remove HTML tags and decode HTML entities
	return text
		.replace(/<[^>]*>/g, '') // Remove HTML tags
		.replace(/&nbsp;/g, ' ') // Replace non-breaking spaces
		.replace(/&amp;/g, '&') // Replace encoded ampersands
		.replace(/&lt;/g, '<') // Replace encoded less-than
		.replace(/&gt;/g, '>') // Replace encoded greater-than
		.trim()
}
</script>

<template>
	<div id="impact" class="grid grid-wrap-3 pt-10 pb-8  m_pb-2 m_pt-5 m_px-1 gap-2 w1050px">
		<div>
			<h3 class="m-0 txt40 regular m_txt30 line-height-13 balance">
				{{ title }}
			</h3>
			<div class="line my-1-5 w160px" />
			<p>
				{{ description }}
			</p>
		</div>

		<div class="grid-span-2 relative">
			<Card
				v-for="(card, idx) in reachCards"
				:key="idx"
				class="bg-gray-light p-2-5 m_p-1-5 mb-1"
			>
				<p class="">
					<span v-if="card.heading" class="bold line-height-0 pe-025">{{ card.heading }}</span>
					{{ cleanHtml(card.description) }}
				</p>
			</Card>
			<p>{{ reachFooter }}</p>
		</div>
	</div>
</template>
